<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="1000px"
            :center="true"
            top="50px"
            :close-on-click-modal="false"
            :before-close="() => closeShopBoxDialog('ShopBoxEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="ShopBox"
                    ref="ShopBoxEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <el-descriptions
                            direction="vertical"
                            :column="2"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center','width':'50%'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>角色框图片</span>
                                </template>
                                <common-upload-component
                                    ref="upload"
                                    :limit=1
                                    :ffileList="ShopBox.picture"
                                ></common-upload-component>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>角色框信息</span>
                                </template>
                                <el-descriptions
                                    class="margin-top"
                                    :column="1"
                                    :labelStyle="{'text-align': 'center','width':'120px'}"
                                    :contentStyle="{'text-align': 'center'}"
                                    border
                                >
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>状态</span>
                                        </template>
                                        <el-select
                                            v-model="ShopBox.state"
                                            filterable
                                            clearable
                                            placeholder="选择状态"
                                            class="state_c"
                                        >
                                            <el-option
                                                v-for="item in AllState"
                                                :key="item.name"
                                                :label="item.name"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>名称</span>
                                        </template>
                                        <el-input v-model="ShopBox.name" placeholder="请填写角色框名称"></el-input>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>代码</span>
                                        </template>
                                        <el-input v-model="ShopBox.code" placeholder="请填写角色框代码"></el-input>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>类型</span>
                                        </template>
                                        <el-select
                                            v-model="ShopBox.type"
                                            filterable
                                            clearable
                                            placeholder="选择角色框属性"
                                            class="type_c"
                                        >
                                            <el-option
                                                v-for="item in AllType"
                                                :key="item.name"
                                                :label="item.name"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2>
                                <template slot="label">
                                    <span>角色框说明</span>
                                </template>
                                <common-editor-component
                                    ref="editor"
                                    :fcontent="ShopBox.note"
                                ></common-editor-component>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div v-else>
                        <el-descriptions
                            direction="vertical"
                            :column="2"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center','width':'50%'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>角色框图片</span>
                                </template>
                                <div style="position: relative;" v-if="ShopBox.picture.length && SinUrl">
                                    <img v-if="ShopBox.picture.length" :src="ShopBox.picture[0].url" height="200px" width="150px" alt="" style="position:absolute;top:0;left:152px;">
                                    <img v-if="SinUrl" :src="SinUrl" height="200px" width="140px" alt="">
                                </div>
                                <div v-else>
                                    <img v-if="ShopBox.picture.length" :src="ShopBox.picture[0].url" height="200px" width="150px" alt="" >
                                </div>
                                <common-upload-component
                                    ref="upload"
                                    v-show="false"
                                    :disabled="true"
                                    :ffileList="ShopBox.picture"
                                ></common-upload-component>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>角色框信息</span>
                                </template>
                                <el-descriptions
                                    class="margin-top"
                                    :column="1"
                                    :labelStyle="{'text-align': 'center','width':'120px'}"
                                    :contentStyle="{'text-align': 'center'}"
                                    border
                                >
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>状态</span>
                                        </template>
                                        <el-tag type="success" v-if="this.is_have_frame">已拥有</el-tag>
                                        <el-tag type="danger" v-else>未拥有</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>名称</span>
                                        </template>
                                        <span>{{ShopBox.name}}</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>类型</span>
                                        </template>
                                        <el-tag effect="plain" type="info" v-if="ShopBox.type === 1">普通</el-tag>
                                        <el-tag effect="plain" v-else-if="ShopBox.type === 2">限定</el-tag>
                                        <el-tag effect="plain" type="danger" v-else-if="ShopBox.type === 3">专属</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>搭配静态皮肤</span>
                                        </template>
                                        <el-select
                                            v-model="PreviewSkin"
                                            filterable
                                            clearable
                                            placeholder="选择静态皮肤"
                                            class="state_c"
                                            @change="changge_skin"
                                        >
                                            <el-option
                                                v-for="item in AllSkin"
                                                :key="item.infant_name"
                                                :label="item.infant_name"
                                                :value="item.url"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>搭配动态皮肤</span>
                                        </template>
                                        <el-select
                                            v-model="PreviewDtSkin"
                                            filterable
                                            clearable
                                            placeholder="选择动态皮肤"
                                            class="state_c"
                                            @change="changge_dt_skin"
                                        >
                                            <el-option
                                                v-for="item in AllDtSkin"
                                                :key="item.name"
                                                :label="item.name"
                                                :value="item.url"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2 :contentStyle="{'text-align':'left','white-space':'pre-line'}">
                                <template slot="label">
                                    <span>角色框说明</span>
                                </template>
                                <div class="el-tiptap-editor__content" v-html="ShopBox.note"></div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="!this.is_have_frame && this.UserItems['常规边框自选'] && (this.UserItems['常规边框自选'] > 0) && (this.ShopBox.type === 1)"
                        type="primary"
                        plain
                        round
                        @click="exchange"
                        >【常规边框自选】卡兑换（剩余{{ this.UserItems['常规边框自选'] }}张）</el-button
                    >
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth)"
                        type="danger"
                        plain
                        @click="ShopBoxDel('ShopBoxEditForm')"
                        >删除</el-button
                    >
                    <el-button
                        plain
                        @click="closeShopBoxDialog('ShopBoxEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('ShopBoxEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('ShopBoxEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeShopBoxDialog('ShopBoxEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('ShopBoxEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="$emit('cancel_edit')"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ShopBoxAddRequest,ShopBoxDelRequest,ShopBoxEditRequest } from '@/network/shop/ShopBox.js'
import { ExchangeFrameRequest } from '@/network/user.js'
import CommonUploadComponent from '@/components/common/CommonUploadComponent'
import CommonEditorComponent from '@/components/common/CommonEditorComponent'

export default {
    name: 'ShopBoxEditComponent',
    data() {
        return {
            login_loading: false,
            ShopBox: {
                state: '',
                name: '',
                picture: [],
                code: '',
                type: '',
                note: ''
            },
            PreviewSkin: '',
            PreviewDtSkin: '',
            SinUrl: ''
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '角色框详情'
            } else if (this.show_type === 1) {
                return '添加角色框'
            } else {
                return '修改角色框'
            }
        },
    },
    methods: {
        closeShopBoxDialog(formName) {
            this.PreviewSkin = '',
            this.PreviewDtSkin = ''
            this.SinUrl = ''
            this.resetForm(formName)
            this.$emit('exitShopBoxDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.ShopBoxInsert(formName)
            })
        },
        ShopBoxInsert(formName) {
            this.login_loading = true
            this.ShopBox.picture = this.$refs.upload.fileList
            this.ShopBox.note = this.$refs.editor.content
            ShopBoxAddRequest(this.ShopBox)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitShopBoxDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.$refs.upload.hideUpload = false
            this.$refs.upload.fileList = []
            this.ShopBox = {
                state: '',
                name: '',
                picture: [],
                code: '',
                note: ''
            }
            this.PreviewSkin = '',
            this.PreviewDtSkin = ''
            this.SinUrl = ''
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.ShopBoxEdit(formName)
            })
        },
        ShopBoxEdit(formName) {
            this.login_loading = true
            this.ShopBox.id = this.id
            this.ShopBox.picture = this.$refs.upload.fileList
            this.ShopBox.note = this.$refs.editor.content
            ShopBoxEditRequest(this.ShopBox)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitShopBoxDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.ShopBox.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        ShopBoxDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    ShopBoxDelRequest(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeShopBoxDialog(formName))
                })
                .catch((err) => {})
        },
        exchange() {
            this.$confirm(
                '是否确定兑换？（将扣除一张对应兑换卡，且不支持7天无理由退货！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    this.login_loading = true
                    ExchangeFrameRequest({frame_id: this.id})
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('兑换成功！')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.loading = false
                            this.$message.error(err)
                        })
                        .finally(() => {
                            this.$emit('RefreshItems')
                            this.$emit('details_row',this.ShopBox.id)
                        })
                        
                        this.login_loading = false
                })
                .catch((err) => {})
        },
        changge_skin(e) {
            this.PreviewDtSkin = ''
            this.SinUrl = e
        },
        changge_dt_skin(e) {
            this.PreviewSkin = ''
            this.SinUrl = e
        }
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        shop_box_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        AllState: {
            type: Array,
            default() {
                return []
            }
        },
        AllType: {
            type: Array,
            default() {
                return []
            }
        },
        AllSkin: {
            type: Array,
            default() {
                return []
            }
        },
        AllDtSkin: {
            type: Array,
            default() {
                return []
            }
        },
        UserItems: {
            type: Object|Array,
            default() {
                return {}
            }
        },
        is_have_frame: {
            type: Boolean,
            default() {
                return true
            }
        },
        edit_auth: String,
        del_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        CommonUploadComponent,
        CommonEditorComponent
    },
    watch: {
        shop_box_details_data(newVal) {
            this.ShopBox = newVal
        },
    },
}
</script>

<style lang='less' scoped>
.state_c,.type_c {
    width: 100%
}
</style>